import { render, staticRenderFns } from "./pvf1.vue?vue&type=template&id=2df31cd5&scoped=true&"
import script from "./pvf1.vue?vue&type=script&lang=js&"
export * from "./pvf1.vue?vue&type=script&lang=js&"
import style0 from "./pvf1.vue?vue&type=style&index=0&id=2df31cd5&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2df31cd5",
  null
  
)

export default component.exports